import { render, staticRenderFns } from "./orderpack.vue?vue&type=template&id=8e34db0c"
import script from "./orderpack.vue?vue&type=script&lang=js"
export * from "./orderpack.vue?vue&type=script&lang=js"
import style0 from "./orderpack.vue?vue&type=style&index=0&id=8e34db0c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports